import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { CustomButtonComponent } from '@frontend/bingo/frontend-lib/core';
import { LoadingIndicatorService } from '@frontend/vanilla/core';

import { FeatureIconComponent } from '../../../components/feature-icon/feature-icon.component';
import { SessionPackageService } from '../../../services/session-package.service';
import { BuyNowBodyComponent } from '../buy-now-body/buynow-body.component';
import { PackagesCashoutComponent } from '../cash-out/packages-cashout.component';

@Component({
    selector: 'bg-sessionbingo-moreinfo',
    templateUrl: 'sessionbingo-moreinfo.component.html',
    imports: [CommonModule, CustomButtonComponent, BuyNowBodyComponent, FeatureIconComponent],
})
export class SessionBingoMoreInfoComponent implements OnInit, OnDestroy {
    PackageDetails: any;
    buyNowItem: any;
    isSessionBingo: boolean;
    isPackageBingo: boolean;
    content: any = [];
    globalClientConfig: any;
    details: any;
    errCount: number = 0;
    sessionId: any;
    ingameStatus: boolean;
    isInGameClient: boolean = false;
    gameId: string;
    disableButton: boolean = false;
    packagePurchased: boolean = false;
    PurchaseButton: boolean = false;
    clientConfig: any;
    package_game_details: any;
    _loadingIndicator: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<SessionBingoMoreInfoComponent>,
        private sessionService: SessionPackageService,
        private loadingIndicatorService: LoadingIndicatorService,
    ) {
        dialogRef.disableClose = true;
    }
    ngOnInit() {
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
            if (!this.globalClientConfig) this.globalClientConfig = this.clientConfig.global;
        }
        this.getPackageDetails();
        if (this.data.sessionData.type == 'session_bingo') {
            this.isSessionBingo = true;
            this.content = this.clientConfig?.sessionGlobalMessages;
        }
        if (this.data.sessionData.type == 'package_bingo') {
            this.isPackageBingo = true;
            this.content = this.clientConfig?.packageGlobalMessages;
        }
    }

    getPackageDetails() {
        this.sessionId = this.data.sessionData.id;
        const package_type = this.data.sessionData.type;
        this._loadingIndicator = this.loadingIndicatorService.start();
        this.sessionService.getPackageDetails(package_type, this.sessionId).subscribe(
            (response: any) => {
                this._loadingIndicator.done();
                if (response) {
                    this.sessionService.onPackageInfoFromPackagesData(this.sessionId, response);
                    this.PackageDetails = this.sessionService.getPackageInfo(this.sessionId);
                }
            },
            () => {
                this._loadingIndicator.done();
            },
        );
    }

    close() {
        this.dialogRef.close();
    }

    private readonly entrypointactive = (customEvent: CustomEvent) => {
        if (customEvent?.detail?.activeFrom && customEvent.detail.activeFrom.toLowerCase() === 'bottom-sticky') {
            dispatchEvent(new CustomEvent('gs:hideFloatingEntry'));
        }
    };

    featureClicked(iconType: any) {
        const iconData = {
            gamefeatureData: iconType,
        };
        this.dialog.open(PackagesCashoutComponent, {
            panelClass: 'packages-cashout-popup',
            data: iconData,
        });
    }
    ngOnDestroy(): void {
        if (this.isInGameClient) {
            dispatchEvent(new CustomEvent('gs:showFloatingEntry'));
            removeEventListener('gs:productstub:entrypoint:active', this.entrypointactive);
        }
    }
}
